import * as React from 'react'

const Wheelchair = (props: any) => (
  <svg {...props} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.5744 11.3942L9.17331 11.9826L7.20834 7.9065L7.01766 7.51275L6.55635 7.5186L2.31006 7.575L2.27106 6.7281H5.7904V5.41095H2.21295L2.08936 2.67585C2.61824 2.46045 2.98854 1.96845 2.98854 1.39575C2.9887 0.624 2.31937 0 1.49467 0C0.668364 0 0 0.624 0 1.39575C0 1.88325 0.268854 2.3127 0.674302 2.5608L0.93176 8.27025L0.959208 8.9097L1.64475 8.901L6.11366 8.84175L8.17814 13.1207L8.46754 13.7205L9.10766 13.4522L11.1514 12.5946L10.5744 11.3942Z'
      transform='translate(3.849)'
    />
    <path
      d='M9.0465 5.1927L8.8571 5.15085C8.44315 6.7326 6.93291 7.83735 5.18784 7.83735C3.10378 7.83735 1.40912 6.2541 1.40912 4.30725C1.40912 3.1083 2.05228 2.01585 3.10539 1.365L2.9269 0.22155L2.80331 0C1.07381 0.83685 0 2.487 0 4.30725C0 6.9792 2.3274 9.15435 5.18784 9.15435C7.15698 9.15435 8.90461 8.1294 9.78325 6.55635L9.0465 5.1927V5.1927V5.1927Z'
      transform='translate(1 5.846)'
    />
  </svg>
)

export default Wheelchair



// WEBPACK FOOTER //
// ./src/components/icons/ui/Wheelchair.tsx